<template>
    <div class="modal-share modal fade" id="changesPriceProduct" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">تغییرات قیمت</h4>
                </div>
                <div class="modal-body">
                    <div class="form-share">
                        <div class="row">
                            <div class="col-12">
                                <div id="container-chart"></div>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <hr />
                            </div>
                            <div class="shopping-page col-md-12 col-lg-12">
                                <ul>
                                    <li style="display:inline-block" class="col-md-3 col-lg-3" v-for="(Info, index) in ProductSaleParams">
                                        <div class="radio">
                                            <input @change="readChangePriceInfo(Info.Id)" type="radio" name="saleParamRadioButton" :id="'radio' + index" :value="Info.Id" v-model="selectedSaleParamsId">
                                            <label :for="'radio' + index">
                                                {{Info.Name != "" ? Info.Name   : "بدون رنگ"}}
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%"><img style="position:absolute;top:50%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" /></div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../module/httpUtility";
    export default {
        data() {
            return {
                selectedSaleParamsId: null,
                isShowSppiner: false
            }
        },
        props: {
            ProductSaleParams: {
                type: Array,
            },
        },
        methods: {
            readChangePriceInfo(ProductSaleParamId) {
                disposeChart();
                this.isShowSppiner = true;
                httpPromise(this, '/v1/ProductManagement/ProductPriceChanges/Read', 'get', { ProductSaleParamId: ProductSaleParamId },
                    response => {

                            initializeChart(response.data.Value.map(x => x.PriceChangeDate), response.data.Value.map(x => x.Price))
                        this.isShowSppiner = false;
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                    });
            },
        },
        beforeMount: function () {
            this.selectedSaleParamsId = this.ProductSaleParams[0] == null ? null : this.ProductSaleParams[0].Id;
            this.ProductSaleParams[0] == null ? null : this.readChangePriceInfo(this.ProductSaleParams[0].Id);
            this.readChangePriceInfo(this.ProductSaleParams[0].Id);
            initializeChart();
        },
        beforeDestroy() {
            disposeChart();
        },
    }

</script>

<style scoped>
    
</style>